module.exports = __webpack_public_path__ + "img/GIF_CANAL.ebc0309d.gif";